import React from "react";

const ArrowIndicator = (props) => {
    const {color, text} = props;
    return (
        <div className="arrow-indicator">
            <div className="circle" style={{background: color}}/>
            <div className="text"> {text} </div>
        </div>
    );
};

export default ArrowIndicator;
